const UNIDADES = ['', 'UN', 'DOS', 'TRES', 'CUATRO', 'CINCO', 'SEIS', 'SIETE', 'OCHO', 'NUEVE'];
const DIEZ_A_DIECINUEVE = [
  'DIEZ', 'ONCE', 'DOCE', 'TRECE', 'CATORCE', 'QUINCE',
  'DIECISEIS', 'DIECISIETE', 'DIECIOCHO', 'DIECINUEVE',
];
const DECENAS = [
  '', '', 'VEINTE', 'TREINTA', 'CUARENTA', 'CINCUENTA',
  'SESENTA', 'SETENTA', 'OCHENTA', 'NOVENTA',
];
const CENTENAS = [
  '', 'CIENTO', 'DOSCIENTOS', 'TRESCIENTOS', 'CUATROCIENTOS', 'QUINIENTOS',
  'SEISCIENTOS', 'SETECIENTOS', 'OCHOCIENTOS', 'NOVECIENTOS',
];

const veintiWords = (unit) => {
  if (unit === 0) return 'VEINTE';
  if (unit === 1) return 'VEINTIUN';
  if (unit === 2) return 'VEINTIDOS';
  if (unit === 3) return 'VEINTITRES';
  if (unit === 4) return 'VEINTICUATRO';
  if (unit === 5) return 'VEINTICINCO';
  if (unit === 6) return 'VEINTISEIS';
  if (unit === 7) return 'VEINTISIETE';
  if (unit === 8) return 'VEINTIOCHO';
  if (unit === 9) return 'VEINTINUEVE';
  return '';
};

/** Convierte 1–999 a letras (español, formato documentos comerciales). */
const convertLessThanThousand = (n) => {
  if (n <= 0) return '';
  if (n === 100) return 'CIEN';

  const hundreds = Math.floor(n / 100);
  const remainder = n % 100;
  const parts = [];

  if (hundreds > 0) {
    parts.push(CENTENAS[hundreds]);
  }

  if (remainder >= 10 && remainder < 20) {
    parts.push(DIEZ_A_DIECINUEVE[remainder - 10]);
  } else if (remainder >= 20 && remainder < 30) {
    parts.push(veintiWords(remainder % 10));
  } else {
    const tens = Math.floor(remainder / 10);
    const units = remainder % 10;
    if (tens > 0) {
      parts.push(units > 0 ? `${DECENAS[tens]} Y ${UNIDADES[units]}` : DECENAS[tens]);
    } else if (units > 0) {
      parts.push(UNIDADES[units]);
    }
  }

  return parts.join(' ').trim();
};

/** Entero ≥ 0 a letras en mayúsculas. */
export const integerToSpanishWords = (n) => {
  const num = Math.floor(Math.abs(Number(n) || 0));
  if (num === 0) return 'CERO';
  if (num === 1) return 'UN';

  const millions = Math.floor(num / 1_000_000);
  const thousands = Math.floor((num % 1_000_000) / 1000);
  const remainder = num % 1000;
  const parts = [];

  if (millions > 0) {
    parts.push(millions === 1 ? 'UN MILLON' : `${convertLessThanThousand(millions)} MILLONES`);
  }
  if (thousands > 0) {
    parts.push(thousands === 1 ? 'MIL' : `${convertLessThanThousand(thousands)} MIL`);
  }
  if (remainder > 0) {
    parts.push(convertLessThanThousand(remainder));
  }

  return parts.join(' ').trim();
};

/**
 * Monto en formato peruano: "CUARENTA CON 0/100 SOLES"
 */
export const amountToWordsSoles = (amount) => {
  const num = Math.round((parseFloat(amount) || 0) * 100) / 100;
  const entero = Math.floor(num);
  const centavos = Math.round((num - entero) * 100);
  const letras = integerToSpanishWords(entero);
  return `${letras} CON ${centavos}/100 SOLES`;
};
